import { useRoute } from 'app/hooks/navigation';
import { useUserTypesConfig } from 'app/network/user';
import type { UserType } from 'app/types/user';
import { FeatureFlag, isFeatureEnabled } from 'app/utils/helpers';

export function useCredentialsActivationFlags() {
  const route = useRoute<'credentials'>();
  const { data: userTypesConfig } = useUserTypesConfig();
  const userType = route.params?.userType as UserType | undefined;

  const userTypeConfig = userType ? userTypesConfig?.find((c) => c.name === userType) : undefined;

  const requireActivationCode = isFeatureEnabled(FeatureFlag.requireActivationCodeDuringSignup, userTypeConfig);
  const possibleActivationCode =
    isFeatureEnabled(FeatureFlag.possibleActivationCodeDuringSignup, userTypeConfig) || requireActivationCode;

  return { possibleActivationCode, requireActivationCode, userType };
}
